/**
 * Application Form Translations - English (EN-US)
 */
export const applicationEn = {
  // Modal
  'application.modal.title': 'Apply for Position',
  'application.modal.closeAriaLabel': 'Close application modal',
  'application.modal.description': 'Application form for submitting your job application. This is a multi-step process where you will provide your contact information, upload your CV, and review your submission.',

  // Step titles
  'application.steps.contactInfo': 'Contact Information',
  'application.steps.uploadCv': 'Upload CV',
  'application.steps.review': 'Review & Submit',

  // Candidate info form (Step 1)
  'application.form.fullName': 'Full Name',
  'application.form.fullNamePlaceholder': 'John Doe',
  'application.form.email': 'Email',
  'application.form.emailPlaceholder': 'john.doe@example.com',
  'application.form.phone': 'Phone Number',
  'application.form.phonePlaceholder': '+55 11 98765-4321',
  'application.form.linkedIn': 'LinkedIn URL',
  'application.form.linkedInPlaceholder': 'https://linkedin.com/in/yourname',

  // Validation messages
  'application.validation.fullNameRequired': 'Please enter your full name',
  'application.validation.emailInvalid': 'Please enter a valid email address',
  'application.validation.phoneInvalid': 'Please enter a valid phone number with country code (e.g., +55 11 98765-4321)',
  'application.validation.linkedInInvalid': 'Please enter a valid URL (e.g., https://linkedin.com/in/yourname)',

  // CV Upload (Step 2)
  'application.upload.dragDrop': 'Drag and drop your CV here, or click to browse',
  'application.upload.fileTypes': 'PDF, DOC, or DOCX files only (max 10MB)',
  'application.upload.preparing': 'Preparing upload...',
  'application.upload.uploading': 'Uploading...',
  'application.upload.success': 'Successfully uploaded',
  'application.upload.retryButton': 'Retry Upload',
  'application.upload.dropzoneAriaLabel': 'Click or drag and drop to upload CV',
  'application.upload.progressAriaLabel': 'Upload progress: {{percent}}%',

  // Upload errors
  'application.upload.error.invalidType': 'Invalid file type. Please upload a PDF, DOC, or DOCX file.',
  'application.upload.error.invalidFormat': 'Invalid file format. Please upload a PDF, DOC, or DOCX file.',
  'application.upload.error.tooLarge': 'File size must be less than 10MB.',
  'application.upload.error.failed': 'Upload failed. Please try again.',
  'application.upload.error.network': 'Network error. Please check your connection and try again.',
  'application.upload.error.timeout': 'Upload timed out. Please try again.',
  'application.upload.error.expired': 'Upload URL expired. Please try again.',
  'application.upload.error.server': 'Server error. Please try again.',

  // Review (Step 3)
  'application.review.contactInfo': 'Contact Information',
  'application.review.fullName': 'Full Name',
  'application.review.email': 'Email',
  'application.review.phone': 'Phone Number',
  'application.review.linkedIn': 'LinkedIn Profile',
  'application.review.cv': 'Curriculum Vitae',
  'application.review.editContactAriaLabel': 'Edit contact information',
  'application.review.editCvAriaLabel': 'Edit CV',
  'application.review.readyToSubmit': 'Ready to submit?',
  'application.review.readyToSubmitDescription': 'Please review your information above. Once submitted, you cannot make changes to this application.',
  'application.review.missingInfo': 'Missing required information. Please complete the previous steps.',
  'application.review.submitButton': 'Submit Application',
  'application.review.submittingButton': 'Submitting...',
  'application.review.submitAriaLabel': 'Submit application',
  'application.review.submittingAriaLabel': 'Submitting application',

  // Submission errors
  'application.submit.error.missingInfo': 'Missing required information. Please complete all steps.',
  'application.submit.error.duplicate': 'You have already applied to this position.',
  'application.submit.error.invalidData': 'Invalid application data. Please check your information.',
  'application.submit.error.notAvailable': 'This job posting is no longer available.',
  'application.submit.error.server': 'Server error. Please try again later.',
  'application.submit.error.generic': 'Failed to submit application. Please try again.',

  // Success message
  'application.success.title': 'Application submitted successfully!',
  'application.success.subtitle': 'We\'re excited to learn more about you. Keep an eye on your email!',
  'application.success.nextStepsTitle': 'What happens next?',
  'application.success.nextStepsDescription': 'We\'ll review your application and contact you within 5 business days if we\'d like to move forward.',
  'application.success.closeAriaLabel': 'Close success message and return to job details',
}
